import React from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import PersonaSelect from '../personas/Select.js'
import { useQuery } from 'react-query';
import PhoneNumber from '../phone_numbers/PhoneNumber.js';

export default function Show() {
  const { id } = useParams();
  const { isLoading, error, data } = useQuery(['phone_number', id], () => PhoneNumber.show(id), {
    placeholderData: {
      area_code: '',
      status: '',
      external_id: ''
    }
  })

  return (
    <Container>
      {isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {error}
            </Alert>
          </Col>
        </Row>
      )}
      <Row className='pt-3'>
        <h1 className='display-6'>Phone Number</h1>
        <Col>
          <FloatingLabel label="Area Code" className="mb-3">
            <Form.Control disabled type="text" value={data.area_code} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Status" className="mb-3">
            <Form.Control disabled type="text" value={data.status} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Number" className="mb-3">
            <Form.Control disabled type="text" value={data.number} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="External ID" className="mb-3">
            <Form.Control disabled type="text" value={data.external_id} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Created" className="mb-3">
            <Form.Control disabled type="text" placeholder="Created" value={data.created_at} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FloatingLabel label="Updated" className="mb-3">
            <Form.Control disabled type="text" placeholder="Updated" value={data.updated_at} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to={`/phone_numbers`} className="btn">
            Back to phone numbers
          </Link>
        </Col>
      </Row>
    </Container>
  )
}